import { AdmiralCardWarning } from '../AdmiralCardWarning';
import * as React from 'react';
import { ICalculationError } from '../../../../../services/quote/models';
import { get } from 'lodash';

interface ICalculationErrorProps {
  calculationError: ICalculationError,
}

export const CalculationError = ({ calculationError }: ICalculationErrorProps) => {

  if (!calculationError) {
    return null
  }

  const component = get(calculationError, 'component');
  const text = get(calculationError, 'message');
  const body = text ? text : (component ? component : '');

  return (
    <div style={{ maxWidth: '600px', margin: 'auto', height: '100vh' }}>
      <AdmiralCardWarning icon={'warning.svg'} title={'No Quotes are available'}>
        {body}
      </AdmiralCardWarning>
    </div>
  )


}
